import TradeCheckboxes from './trade-checkboxes';

$(() => {
  if ($('.category__selector').length) {
    HandshqApp.generateMasterActivitiesCollection();
    $('.master-activities-container').addClass('in');
    new TradeCheckboxes({ selector: '.trade_checkbox' }).setup();
  }
});
